export const buttonsTypes = {
    SAVE: 'save',
    EDIT: 'edit',
    PUBLISH: 'publish',
    EXPORT: 'export',
    PREVIEW: 'preview',
    SAVE_SEND: 'save_send',
    DUPLICATE: 'duplicate',
    HISTORY: 'history',
    REJECT: 'reject',
    APPROVE: 'approve',
    CANCEL: 'cancel',
    OBSOLETE: 'obsolete',
    CLEAR: 'clear',
    DOWNLOAD: 'download',
    DOWNLOAD_OP2: 'download_OP2',
    DOWNLOAD_PDF: 'download_pdf',
    DOWNLOAD_DOCX: 'download_docx',
    CREATE_DOCUMENT: 'create_document',
    CREATE_BLOCK: 'create_block',
    CREATE_SECTION: 'create_section',
    CREATE_SNIPPET: 'create_snippet',
    CREATE_USER: 'create_user',
    CREATE_REGION: 'create_region',
    CREATE_BUSINESS: 'create_business',
    CREATE_LOGO: 'create_logo',
    CREATE_TEMPLATE: 'create_template',
    CREATE_TABLE_STYLE: 'create_table_style',
    CREATE_LIST_STYLE: 'create_list_style',
    CREATE_TEXT_STYLE: 'create_text_style',
}

const baseClass = 'd-flex align-items-center gap-3 font-size-20 waves-effect waves-light btn-rounded btn-padding';
const btn = (variant) => `${variant} ${baseClass}`;

export const buttonsConfig = {
    [buttonsTypes.SAVE]: {
        label: 'Save',
        icon: 'fas fa-save',
        variant: btn('btn-braskemPrimary'),
    },

    [buttonsTypes.EDIT]: {
        label: 'Edit',
        icon: 'fas fa-edit',
        variant: btn('btn-braskemWarning'),
    },

    [buttonsTypes.PUBLISH]: {
        label: 'Publish',
        icon: 'fas fa-check',
        variant: btn('btn-braskemSuccess'),
    },

    [buttonsTypes.EXPORT]: {
        label: 'Export',
        icon: 'fas fa-file-excel',
        variant: btn('btn-light'),
    },

    [buttonsTypes.PREVIEW]: {
        label: 'Preview',
        icon: 'fas fa-search',
        variant: btn('btn-braskemGray300'),
    },

    [buttonsTypes.SAVE_SEND]: {
        label: 'Save & Send to Review',
        icon: 'fas fas fa-share',
        variant: btn('btn-braskemInfo'),
    },

    [buttonsTypes.DUPLICATE]: {
        label: 'Duplicate',
        icon: 'fas fa-clone',
        variant: btn('btn-braskemGray300'),
    },

    [buttonsTypes.HISTORY]: {
        label: 'History',
        icon: 'fas fa-history',
        variant: btn('btn-braskemGray300'),
    },

    [buttonsTypes.REJECT]: {
        label: 'Reject',
        icon: 'fas fa-check',
        variant: btn('btn-braskemDanger'),
    },

    [buttonsTypes.APPROVE]: {
        label: 'Approve',
        icon: 'fas fa-check',
        variant: btn('btn-braskemInfo'),
    },

    [buttonsTypes.CANCEL]: {
        label: 'Cancel',
        icon: 'fas fa-ban',
        variant: btn('btn-braskemGray200'),
    },

    [buttonsTypes.OBSOLETE]: {
        label: 'Obsolete',
        icon: 'fas fa-flag',
        variant: btn('btn-braskemGray300'),
    },

    [buttonsTypes.CLEAR]: {
        label: 'Clear Selection',
        icon: 'fas fa-ban',
        variant: btn('btn-braskemGray200'),
    },

    [buttonsTypes.DOWNLOAD]: {
        label: 'Download',
        variant: btn('btn-white'),
    },

    [buttonsTypes.DOWNLOAD_OP2]: {
        label: 'Download',
        icon: 'fas fa-download',
        variant: btn('btn-light'),
    },

    [buttonsTypes.DOWNLOAD_PDF]: {
        label: 'Download',
        icon: 'fas fa-file-pdf',
        variant: btn('btn-braskemMagenta'),
    },

    [buttonsTypes.DOWNLOAD_DOCX]: {
        label: 'Download',
        icon: 'fas fa-file-word',
        variant: btn('btn-braskemInfo'),
    },

    [buttonsTypes.CREATE_DOCUMENT]: {
        label: 'Create New Document',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

    [buttonsTypes.CREATE_BLOCK]: {
        label: 'Create New Block',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

    [buttonsTypes.CREATE_SECTION]: {
        label: 'Create New Section',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

    [buttonsTypes.CREATE_SNIPPET]: {
        label: 'Create New Snippet',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

     [buttonsTypes.CREATE_USER]: {
        label: 'Create New User',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

     [buttonsTypes.CREATE_REGION]: {
        label: 'Create New Region',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

     [buttonsTypes.CREATE_BUSINESS]: {
        label: 'Create New Business',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

     [buttonsTypes.CREATE_LOGO]: {
        label: 'Create New Logo',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },

    [buttonsTypes.CREATE_TEMPLATE]: {
        label: 'Create New Template',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },
    [buttonsTypes.CREATE_TABLE_STYLE]: {
        label: 'Create New Table Style',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },
    [buttonsTypes.CREATE_LIST_STYLE]: {
        label: 'Create New List Style',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },
    [buttonsTypes.CREATE_TEXT_STYLE]: {
        label: 'Create New Text Style',
        icon: 'fas fa-plus-square',
        variant: btn('btn-braskemPrimary'),
    },
}
